"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REACT_APP_PROCESS_ENV = exports.STD_PROCESS_ENV = void 0;
exports.STD_PROCESS_ENV = (({ AWS_DEFAULT_REGION, AWS_PROFILE, accountId, projectCode, projectName, stage }) => ({
    AWS_DEFAULT_REGION,
    AWS_PROFILE,
    accountId,
    projectCode,
    projectName,
    stage,
}))(process.env);
exports.REACT_APP_PROCESS_ENV = (({ REACT_APP_CURRENT_GIT_SHA, REACT_APP_AWS_ACCOUNT_ID, REACT_APP_DEPLOYMENT_STAGE, REACT_APP_PROJECT_CODE, REACT_APP_PROJECT_NAME, REACT_APP_AWS_DEFAULT_REGION, }) => ({
    REACT_APP_CURRENT_GIT_SHA,
    REACT_APP_AWS_ACCOUNT_ID,
    REACT_APP_DEPLOYMENT_STAGE,
    REACT_APP_PROJECT_CODE,
    REACT_APP_PROJECT_NAME,
    REACT_APP_AWS_DEFAULT_REGION,
}))(process.env);
